// src/api/errors.ts
export class ApiError extends Error {
  constructor(
    public status: number,
    message: string,
    public raw?: unknown,
    public mfaRequired = false,
    public retryAfter?: number,
  ) {
    super(message);
    this.name = "ApiError";
  }
}

// ctx.max_length/min_length جايين من Pydantic v2 نفسه لما النوع string_too_long/string_too_short
// (نفس الأسماء الحرفية اللي الباك إند بيرجعها) — مش حقول اخترعناها إحنا.
type ValidationItem = { loc?: (string | number)[]; msg?: string; type?: string; ctx?: { max_length?: number; min_length?: number } };

/** رسالة عربية جاهزة للعرض: الخادم يرجع detail نصاً، وأخطاء 422 قائمة حقول. */
export function detailToMessage(status: number, body: unknown): string {
  const detail = (body as { detail?: unknown } | null)?.detail;
  if (typeof detail === "string" && detail) return detail;
  if (Array.isArray(detail) && detail.length) {
    const first = detail[0] as ValidationItem;
    const field = first.loc?.filter((p) => p !== "body").join(".") ?? "";
    // الحالتين الأشيع (طول النص أكبر/أصغر من المسموح) بنوضحهم بالرقم الفعلي بدل الرسالة العامة الغامضة
    // "قيمة غير صالحة" اللي مش بتقول للمستخدم إيه بالظبط المشكلة ولا إزاي يصلّحها.
    if (first.type === "string_too_long" && first.ctx?.max_length != null) {
      return `النص في الحقل (${field}) أطول من المسموح — الحد الأقصى ${first.ctx.max_length} حرف`;
    }
    if (first.type === "string_too_short" && first.ctx?.min_length != null) {
      return `النص في الحقل (${field}) أقصر من المطلوب — الحد الأدنى ${first.ctx.min_length} حرف`;
    }
    return field ? `قيمة غير صالحة في الحقل (${field})` : "بيانات غير صالحة";
  }
  if (status === 401) return "انتهت الجلسة، سجّل الدخول من جديد";
  if (status === 403) return "ماعندكش صلاحية لهذا الإجراء";
  if (status === 404) return "العنصر غير موجود";
  if (status >= 500) return "حدث خطأ في الخادم، حاول مرة أخرى";
  return "تعذّر إتمام العملية";
}

/** 429: نُضيف مدة الانتظار من ترويسة Retry-After كي يعرف المستخدم متى يعيد المحاولة. */
export function withRetryHint(message: string, status: number, retryAfterSeconds?: number): string {
  if (status !== 429 || !retryAfterSeconds) return message;
  const wait = retryAfterSeconds >= 120 ? `${Math.ceil(retryAfterSeconds / 60)} دقيقة` : `${retryAfterSeconds} ثانية`;
  return `${message} — حاول بعد ${wait}`;
}

export const errorMessage = (err: unknown): string =>
  err instanceof ApiError ? err.message : err instanceof Error ? "تعذّر الاتصال بالخادم" : "حدث خطأ غير متوقع";
